import { render, staticRenderFns } from "./LaboratoryDetail.vue?vue&type=template&id=734fc94e"
import script from "./LaboratoryDetail.vue?vue&type=script&lang=js"
export * from "./LaboratoryDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports